export const SET_DEVICES_FILTERS = 'SET_DEVICES_FILTERS';
export const SET_SIMCARDS_FILTERS = 'SET_SIMCARDS_FILTERS';
export const SET_GPS_FILTERS = 'SET_GPS_FILTERS';

export const setDevicesFilters = ({ search = '', from_created = '', to_created = '', status = '', substatus = '', enabled = '' } = {}) => ({
    type: SET_DEVICES_FILTERS,
    payload: {
        search,
        from_created,
        to_created,
        status,
        substatus,
        enabled
    }
});

export const setSimcardsFilters = ({ search = '', from_created = '', to_created = '', status = '', substatus = '', enabled = '' } = {}) => ({
    type: SET_SIMCARDS_FILTERS,
    payload: {
       search,
       from_created,
       to_created,
       status,
       substatus,
       enabled
    }
});

export const setGpsFilters = ({ 
    search= '', 
    status = '', 
    enabled = '', 
    assigned = '',
    date = '',
    imei = '',
    simcard = '',
    substatus = ''
} = {}) => ({
    type: SET_GPS_FILTERS,
    payload: {
        search,
        status,
        enabled,
        assigned,
        date,
        imei,
        simcard,
        substatus
    }
});
